var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 13,
    viewBox: "0 0 25 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60411 0.36488C2.0748 -0.13574 1.2556 -0.119157 0.774383 0.401919C0.293164 0.922995 0.33215 1.75124 0.861461 2.25186L11.1455 11.9785C11.1869 12.045 11.235 12.1084 11.2899 12.1678C11.5464 12.4455 11.8988 12.5799 12.2523 12.5691C12.6057 12.5799 12.9581 12.4455 13.2146 12.1678C13.2695 12.1084 13.3176 12.045 13.359 11.9785L23.6431 2.25186C24.1724 1.75124 24.2114 0.922995 23.7301 0.401919C23.2489 -0.119157 22.4297 -0.13574 21.9004 0.36488L12.2523 9.49006L2.60411 0.36488Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.172d60360e73481097ce9f289e547576.svg";
export { ForwardRef as ReactComponent };